module.exports = __webpack_public_path__ + "static/bielenda_main_3-4f0d3f2bc77e3130fdcfcbce7c20d406.png";